import { setCurrectChat } from "../redux/admin-slices/socket.slice"
import { useDispatch, useSelector } from "react-redux"

export const useChatInitiate = () => {
  const dispatch = useDispatch()
  const { chat, socket } = useSelector((state) => state.socketSlice)

  const initiateChat = async (chat) => {
    dispatch(setCurrectChat(chat))
    socket.emit("join-room", chat?._id)
  }

  return {
    initiateChat,
    isActive: !!Object.keys(chat || {})?.length,
  }
}